import { render, staticRenderFns } from "./AllSearch.vue?vue&type=template&id=a2e55cea&scoped=true"
import script from "./AllSearch.vue?vue&type=script&lang=js"
export * from "./AllSearch.vue?vue&type=script&lang=js"
import style0 from "./AllSearch.vue?vue&type=style&index=0&id=a2e55cea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e55cea",
  null
  
)

export default component.exports